import React, { useCallback, useEffect, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { getColor, Link, Text, vars } from '@flodesk/grain';

import { Character } from './Character';

const styles = {
  link: css`
    display: flex;
    line-height: 1;
    color: ${getColor('dark')};
    text-decoration: none;
    height: 28px;
    aspect-ratio: ${127 / 36};
    position: relative;
  `,
  content: css`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    line-height: 1;
    font-family: 'FlotesqueGX';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: translate(-50%, -50%);

    span {
      display: inline-flex;
      align-items: center;
    }
  `,
};

const chars = 'flodesk';
const duration = 1000;
const delay = 10000;

export function FlodeskLogo() {
  const [isActive, setIsActive] = useState(false);

  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    setIsActive(true);
    timerRef.current = setInterval(() => {
      setIsActive(true);
    }, delay);

    return () => {
      setIsActive(false);
      clearTimeout(timerRef.current);
    };
  }, []);

  const handleAnimationEnd = useCallback(
    (index: number) => () => {
      if (index === chars.length - 1) {
        setIsActive(false);
      }
    },
    [],
  );

  const handleMouseOver = () => {
    setIsActive(true);
  };

  return (
    <Link href="/" aria-label="Logo" onMouseOver={handleMouseOver} css={styles.link}>
      <Text size={vars.texts.xl} color={vars.colors.content} css={styles.content}>
        {chars.split('').map((char, index) => (
          <Character
            key={`${char}`}
            duration={duration}
            isActive={isActive}
            index={index}
            chars={chars}
            onAnimationEnd={handleAnimationEnd(index)}
          >
            {char}
          </Character>
        ))}
      </Text>
    </Link>
  );
}
